import { styled, Caption, Title, SubTitle } from '@teko/ds-desktop';
import React from 'react';
import { formatCurrency } from '../../helpers/number.es.js';

const isShowRetailPrice = (supplierRetailPrice, latestPrice, numberDisplayFormat) => {
  let newSupplierRetailPrice = supplierRetailPrice;
  let newLatestPrice = latestPrice;
  const { thousandSeparator = ".", decimalSeparator = "," } = numberDisplayFormat || {};
  const parseStringPrice = (price) => price.replace(/[₫đ]/g, "").replace(thousandSeparator, "").replace(decimalSeparator, ".");
  if (typeof supplierRetailPrice === "string") {
    newSupplierRetailPrice = parseStringPrice(supplierRetailPrice);
  }
  if (typeof latestPrice === "string") {
    newLatestPrice = parseStringPrice(latestPrice);
  }
  return Number(newSupplierRetailPrice) > Number(newLatestPrice);
};
const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  discountPercent,
  textColor = "primary500",
  align = "start",
  size = "m",
  className,
  priceRange,
  numberDisplayFormat,
  uomSuffix,
  weight
}) => {
  const formattedRetailPrice = typeof supplierRetailPrice === "number" ? formatCurrency(supplierRetailPrice, numberDisplayFormat) : supplierRetailPrice;
  const formattedLatestPrice = typeof latestPrice === "number" ? formatCurrency(latestPrice, numberDisplayFormat) : latestPrice;
  let renderedRetailPrice, renderedDiscount;
  const renderedLatestPrice = () => {
    if (!priceRange) {
      return size === "l" ? /* @__PURE__ */ React.createElement(Title, {
        className: "att-product-detail-latest-price",
        level: 2,
        color: textColor,
        weight: weight || "bold"
      }, formattedLatestPrice) : /* @__PURE__ */ React.createElement(SubTitle, {
        className: "att-product-detail-latest-price",
        level: 1,
        color: textColor,
        weight
      }, formattedLatestPrice);
    }
    const formattedMinPrice = formatCurrency(priceRange.min, numberDisplayFormat, false);
    const formattedMaxPrice = formatCurrency(priceRange.max, numberDisplayFormat);
    return size === "l" ? /* @__PURE__ */ React.createElement(StyledTitle, {
      level: 2,
      color: textColor,
      weight: weight || "bold",
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice) : /* @__PURE__ */ React.createElement(StyledSubTitle, {
      level: 1,
      color: textColor,
      line: 1,
      weight
    }, formattedMinPrice, " - ", formattedMaxPrice);
  };
  switch (size) {
    case "l":
      renderedRetailPrice = /* @__PURE__ */ React.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ React.createElement(Caption, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
    default:
      renderedRetailPrice = /* @__PURE__ */ React.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ React.createElement(Caption, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
  }
  const showRetailPrice = supplierRetailPrice && isShowRetailPrice(supplierRetailPrice, latestPrice, numberDisplayFormat);
  const isShowDiscount = !!discountPercent;
  return /* @__PURE__ */ React.createElement(ProductPriceWrapper, {
    align,
    className
  }, uomSuffix ? /* @__PURE__ */ React.createElement(LatestPriceRow, null, renderedLatestPrice(), /* @__PURE__ */ React.createElement(UomSuffix, null, "/", uomSuffix)) : renderedLatestPrice(), (showRetailPrice || isShowDiscount) && /* @__PURE__ */ React.createElement(StyledDiscount, null, showRetailPrice && renderedRetailPrice, isShowDiscount && renderedDiscount));
};
const ProductPriceWrapper = styled.div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
  height: 2.5rem;
`);
const StyledRetailPrice = styled(Caption)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const StyledDiscount = styled.div`
  display: flex;
  height: 1rem;
`;
const LatestPriceRow = styled.div`
  display: flex;
  align-items: baseline;
`;
const UomSuffix = styled.span`
  font-size: 13px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.45);
`;
const StyledTitle = styled(Title)`
  word-break: break-all;
`;
const StyledSubTitle = styled(SubTitle)`
  word-break: break-all;
`;

export { ProductPrice };
